import type { ButtonProps } from "@ecco/ui/button";
import { space, typography } from "@ecco/ui/tokens";

const { fontSizes } = typography;

export const buttonStyle = {
    height: { base: space["9.6"], sm: space["10.4"] },
    gap: space["3"],
    fontSize: { base: fontSizes.mobileBodyTextNormal, sm: fontSizes.desktopBodyTextNormal },
    _hover: {
        textDecoration: "none",
    },
} satisfies Partial<ButtonProps>;
